<template>
    <div class="zvshk-stepper">
        <div v-if="!loading">
            <template v-if="placeholderHtml">
                <div class="form-placeholder-container" v-html="placeholderHtml"></div>
            </template>
            <template v-else-if="formSubmitted">
                <div class="form-finished-container" v-html="formFinishedHtml"></div>
            </template>
            <template v-else>
                <div class="formtitle">
                    <h2>{{ ogData.form.title }}</h2>
                </div>
                <div class="stepper--progress">
                    <!-- <div class="progress--title">
                        {{ currentSlide }} / {{ maxPages }} ( {{  currentPage }} )
                    </div> -->
                    <div class="progress--bar">
                        <ProgressBar :value="currentStep" style="transition-duration: 100ms; height: 12px" :showValue="false"> {{ currentSlide }} / {{ maxPages }} </ProgressBar>
                    </div>
                </div>
                <form @submit.prevent="onFormSubmit" class="p-form p-component" ref="formEl">

                    <swiper
                        :slides-per-view="1"
                        :space-between="0"
                        :autoHeight="true"
                        no-swiping-class="no-swiping" 
                        @swiper="onSwiper"
                        @slideChange="onSlideChange"
                        aria-live="polite"
                    >
                        <swiper-slide :key="step.name" v-for="(step, key, index) in visibleSlides" tab-index="-1">
                            <div class="stepper-container row">
                                <template v-for="(item, elindex) in step.element_details.fieldsets" :key="item.name">

                                    <div :class="'stepper-single ' + item.newClass">
                                        <!-- label -->
                                        <strong
                                            v-if="
                                                item.type == 'leadRevocationCheckBox'
                                                || (item.value && (item.type == 'tcB2cPrivateFormWithPriceList' || item.type == 'tcB2bPrivateFormWithPriceList'))
                                                || item.label
                                                || (item.description && item.type !== 'note')
                                            "
                                            class="label"
                                        >
                                            <template v-if="item.type == 'leadRevocationCheckBox'">
                                                <span class="headline" v-html="item.attributes['data-extra-label']"></span> <small>{{ getSelectState(item.type) }}</small> <span>{{ item.isRequired ? '*' : '' }}</span>
                                            </template>
                                            <template v-else-if="item.value && (item.type == 'tcB2cPrivateFormWithPriceList' || item.type == 'tcB2bPrivateFormWithPriceList') ">
                                                <span class="headline is-note" v-if="item.value" v-html=" item.value"></span>
                                                <span class="headline" v-else>{{ item.label }}</span>
                                            </template>
                                            <template v-else>
                                                <template v-if="item.label">
                                                    <span class="headline" v-html="item.label"></span> <small>{{ getSelectState(item.type) }}</small> <span>{{ item.isRequired ? '*' : '' }}</span>
                                                </template>
                                                <template v-if="item.description && item.type !== 'note'">
                                                    <Button type="button" class="btn-infopopup" label="i" @click="toggle(`${index}-${elindex}`, $event)" />
    
                                                        <Popover :ref="el => popovers[`${index}-${elindex}`] = el">
                                                            <template v-if="item.attributes['data-extra-label']">
                                                                <div class="infopopup" v-html="item.attributes['data-extra-label']"></div>
                                                            </template>
                                                            <template v-else-if="item.value">
                                                                <div class="infopopup" v-html="item.value"></div>
                                                            </template>
                                                            <template v-else>
                                                                <div class="infopopup" v-html="item.description"></div>
                                                            </template>
                                                        </Popover>
                                                </template>
                                            </template>
                                        </strong>
                                        <!-- label | end -->

                                        <!-- <br> ------------- {{   item.newType}} ------------
                                        <br> -->
                                        <component
                                            :is="com[item.newType + 'Com']"
                                            :data="item"
                                            :step="step.element_details"
                                            :field="validateForm[step.name][item.element_details.name]"
                                            :fields="validateForm[step.name]"
                                            :results="specialistResults"
                                            :form-type="ogData?.form?.formType"

                                            @update:slideForward="submitCurrentSlide"
                                            @update:autoheight="updateSwiperAutoHeight"
                                            @update:formFiles="updateFormFiles"
                                        />
                                        <Message v-if="validateForm[step.name][item.element_details.name]?.invalid" severity="error" size="small" variant="simple">{{ validateForm[step.name][item.element_details.name].error.message }}</Message>
                                    </div>
        
                                </template>
        
                                <div class="error_msg" >
                                    <template v-if="showErrorMessage && currentSlide == maxPages">
                                        <span>{{ errorMessage }}</span>
                                    </template>
                                    <template v-if="!showErrorMessage && currentSlide == maxPages && formIsSubmitting">
                                        <ProgressSpinner style="width: 50px; height: 50px; margin-bottom: 25px;" strokeWidth="8" fill="transparent" animationDuration=".5s" />
                                    </template>
                                </div>
                                <div class="navigations-buttons">
                                    <template v-for="btn in ogData.form.formButtons">
                                        <template v-if="btn.type == 'backButton' && currentSlide != 1">
                                            <Button class="btn-prev" @click="slideBack(key)" severity="secondary" :label="getButtonLabel(btn)" />
                                        </template>
                                        <template v-if="btn.type == 'nextButton' && currentSlide != maxPages">
                                            <Button class="btn-next" type="submit" severity="primary" :label="getButtonLabel(btn)" />
                                        </template>
                                        <template v-if="btn.type == 'submitButton' && currentSlide == maxPages">
                                            <Button class="btn-submit" type="submit" severity="primary" :label="getButtonLabel(btn)" :disabled="formIsSubmitting" />
                                        </template>
                                    </template>
                                </div>
        
                            </div>
                        </swiper-slide>
                    </swiper>
                    <!-- <div class="row">
                        <div class="col-md-4">
                            <h4>responseValues</h4>
                            <pre style="overflow-x: auto;">{{ responseValues }}</pre>
                        </div>
                        <div class="col-md-4">
                            <h4>validateForm</h4>
                            <pre style="overflow-x: auto;">{{ validateForm }}</pre>
                        </div>
                        <div class="col-md-4">
                            <h4>initialValues</h4>
                            <pre style="overflow-x: auto;">{{ initialValues }}</pre>
                        </div>
                    </div> -->
                </form>
            </template>
        </div>

        <template v-else>
            <loadingScreen aria-disabled="true" :progress="progress" />
        </template>
    </div>
</template>

<script setup>
import { ref, onMounted, computed, nextTick, watch, VueElement } from 'vue';
import { Swiper, SwiperSlide  } from 'swiper/vue';
import axios from 'axios';
import WDQuery from "./plugins/query-validator";
import _ from 'underscore';

// add css
import 'swiper/css';

// import components
import loadingScreen from './components/loadingscreen.vue'
import bigRadioCom from './components/fields/bigradio.vue'
import noteCom from './components/fields/note.vue'
import multiCheckboxCom from './components/fields/multicheckbox.vue'
import bigCheckboxesCom from './components/fields/bigcheckboxes.vue'
import textCom from './components/fields/textCom.vue'
import singleSelectCom from './components/fields/singleSelect.vue'
import textareaCom from './components/fields/textareaCom.vue'
import fileuploadCom from './components/fields/fileuploadCom.vue';
import sagsDigitalRecordingCom from './components/fields/sagsDigitalRecordingCom.vue';
import specialistFilterCom from './components/fields/specialistFilter.vue';
import specialistFilterResultContainerCom from './components/fields/specialistFilterResultContainer.vue';
import openApprenticeshipsSelectCom from './components/fields/openApprenticeshipsSelect.vue';
import postcodeCom from './components/fields/postcode.vue';
import radioCom from './components/fields/radioCom.vue';
import termsAndConditionsCom from './components/fields/termsAndConditions.vue'
import rangeSliderCom from './components/fields/rangeSliderCom.vue'

const com = {
    bigRadioCom,
    noteCom,
    multiCheckboxCom,
    bigCheckboxesCom,
    textCom,
    singleSelectCom,
    textareaCom,
    fileuploadCom,
    sagsDigitalRecordingCom,
    specialistFilterCom,
    specialistFilterResultContainerCom,
    openApprenticeshipsSelectCom,
    postcodeCom,
    radioCom,
    termsAndConditionsCom,
    rangeSliderCom,
}

function resolvers(item) {
    const { names, values } = item;
    const errors = {};

    names.forEach((fieldName) => {
        if (fieldName.includes('_wd_filter')) {
            const selectValue = values['sf_select'];
            errors[fieldName] = [];

            if (selectValue === 'Postleitzahl') {
                ['sf_plzInputValue'].forEach(specialKey => {
                    const val = values[specialKey];
                    if (
                        val === undefined ||
                        val === null ||
                        (typeof val === 'string' && val.trim() === '') ||
                        (Array.isArray(val) && val.length === 0)
                    ) {
                        errors[fieldName].push({
                            message: '-1',
                            field: specialKey,
                            fieldmessage: 'Bitte eine Postleitzahl eingeben.'
                        });
                    } else {
                        if (errors.hasOwnProperty(fieldName)) {
                            delete errors[fieldName];
                        }
                    }
                });
            } else if (selectValue === 'Firmenname') {
                const val = values['sf_companyValue'];
                if (
                    val === undefined ||
                    val === null ||
                    (typeof val === 'string' && val.trim() === '') ||
                    (Array.isArray(val) && val.length === 0)
                ) {
                    errors[fieldName].push({
                        message: '-1',
                        field: 'sf_companyValue',
                        fieldmessage: 'Bitte ein Suchwort eingeben.'
                    });
                } else {
                    if (errors.hasOwnProperty(fieldName)) {
                        delete errors[fieldName];
                    }
                }
            }
            specialistFilterErrors.value = errors;
        }
    });

    return { values, errors };
}

function isFieldVisible(item) {
    if (!item?.rule) {
        return true;
    }

    const { matched } = WDQuery.evaluate(item.rule, formData.value)
    return !!matched
}

function normalizeSelectedValues(value) {
    if (value === null || value === undefined || value === '') {
        return [];
    }

    const values = Array.isArray(value) ? value : [value];

    return values
        .map(selectedValue => {
            if (selectedValue && typeof selectedValue === 'object') {
                if ('id' in selectedValue) return selectedValue.id;
                if ('value' in selectedValue) return selectedValue.value;
            }

            return selectedValue;
        })
        .filter(selectedValue => selectedValue !== null && selectedValue !== undefined && selectedValue !== '');
}

function isTruthyAttribute(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
}

function getOptionAttributes(option) {
    return option?.attributes && typeof option.attributes === 'object' ? option.attributes : {};
}

function getAllFormFields(data = ogData.value) {
    const fieldsets = getFormFieldsets(data);
    if (!fieldsets) return [];

    return fieldsets.flatMap(page => page.element_details?.fieldsets ?? []);
}

function getSelectedFieldValue(item) {
    if (!item) return null;

    if (Object.prototype.hasOwnProperty.call(formData.value, item.id)) {
        return formData.value[item.id];
    }

    if (Object.prototype.hasOwnProperty.call(initialValues.value, item.id)) {
        return initialValues.value[item.id];
    }

    return item.value;
}

function isSelectedOption(option, selectedValues) {
    return selectedValues.some(selectedValue => String(selectedValue) === String(option?.value));
}

function isRepairServiceField(item) {
    if (item?.searchField === 'wd_repair_services_ids') return true;
    if (isTruthyAttribute(item?.attributes?.['data-repair-services'])) return true;

    return (item?.valueOptions ?? []).some(option => {
        const attributes = getOptionAttributes(option);
        return isTruthyAttribute(attributes['data-repair-services']) || attributes['data-urgent'] !== undefined;
    });
}

function isConsumerTypeField(item) {
    if (item?.searchField === 'wd_consumer_types') return true;
    if (isTruthyAttribute(item?.attributes?.['data-consumer-type'])) return true;

    return (item?.valueOptions ?? []).some(option => {
        const attributes = getOptionAttributes(option);
        return attributes['data-show-revocation-checkBox'] !== undefined || attributes['data-show-revocation-checkbox'] !== undefined;
    });
}

function getShowRevocationAttribute(attributes) {
    return attributes['data-show-revocation-checkBox'] ?? attributes['data-show-revocation-checkbox'];
}

function selectedConsumerTypeAllowsRevocation() {
    const consumerTypeFields = getAllFormFields().filter(field => isConsumerTypeField(field) && isFieldVisible(field));
    if (consumerTypeFields.length === 0) return true;

    let hasSelectedConsumerType = false;
    let hasRevocationConsumerType = false;

    consumerTypeFields.forEach(field => {
        const selectedValues = normalizeSelectedValues(getSelectedFieldValue(field));
        if (selectedValues.length === 0) return;

        hasSelectedConsumerType = true;

        (field.valueOptions ?? []).forEach(option => {
            if (!isSelectedOption(option, selectedValues)) return;

            const showRevocation = getShowRevocationAttribute(getOptionAttributes(option));
            if (showRevocation === undefined || isTruthyAttribute(showRevocation)) {
                hasRevocationConsumerType = true;
            }
        });
    });

    return hasSelectedConsumerType ? hasRevocationConsumerType : true;
}

function repairSelectionAllowsRevocation() {
    const selectedRepairOptions = [];

    getAllFormFields()
        .filter(field => isRepairServiceField(field) && isFieldVisible(field))
        .forEach(field => {
            const selectedValues = normalizeSelectedValues(getSelectedFieldValue(field));
            if (selectedValues.length === 0) return;

            (field.valueOptions ?? []).forEach(option => {
                if (isSelectedOption(option, selectedValues)) {
                    selectedRepairOptions.push(option);
                }
            });
        });

    if (selectedRepairOptions.length === 0) return true;

    return selectedRepairOptions.some(option => !isTruthyAttribute(getOptionAttributes(option)['data-urgent']));
}

function shouldShowLeadRevocationCheckBox() {
    return selectedConsumerTypeAllowsRevocation() && repairSelectionAllowsRevocation();
}

function isRuntimeVisible(item) {
    if (item?.type !== 'leadRevocationCheckBox') return true;

    return shouldShowLeadRevocationCheckBox();
}

function addHiddenLeadRevocationValues(values) {
    const fieldsets = getFormFieldsets();
    if (!fieldsets) return;

    fieldsets.forEach(page => {
        (page.element_details?.fieldsets ?? []).forEach(item => {
            if (item?.type !== 'leadRevocationCheckBox') return;
            if (isFieldVisible(item) && isRuntimeVisible(item)) return;
            if (!isFieldVisible(item)) return;

            const pageName = page.name;
            const fieldName = item.element_details?.name;
            if (!pageName || !fieldName) return;

            if (!values[pageName]) {
                values[pageName] = {};
            }

            values[pageName][fieldName] = 1;
        });
    });
}

// vars
const loading = ref(true);
const swiperInstance = ref()
const progress = ref(0);
const queryUID = new URLSearchParams(window.location.search).get('uid') ?? 'a83a2e7e-e8a6-457f-b326-4d90ec300026';
const querySUID = new URLSearchParams(window.location.search).get('suid') ?? '';
const ogData = ref(null);
const currentPage = ref(1);
const currentSlide = ref(1);
const goToNextPage = ref(1)
const goToPrevPage = ref(null)
const pagesArray = ref([]);
const maxPages = ref(0);
const formData = ref({});
const formNames = ref({});
const formEl = ref(null)
const errorMessage = ref('Einige Felder müssen noch ausgefüllt werden.');
const showErrorMessage = ref(false);
const formSubmitted = ref(false);
const formFinishedHtml = ref('');
const formIsSubmitting = ref(false);
const formFiles = ref({});
const searchParams = ref({});
const specialistResults = ref(null);
const privateFieldExceptions = ref(['specialistFilter', 'specialistFilterResultContainer']);
const specialistFilterErrors = ref({});
const placeholderHtml = ref('');


/**
 * New Conzept
**/

/**
 * Variables
**/

const validateForm = ref({valid: true});
const validateFormSaver = ref({valid: true});
const oldvalidateFromSaver = ref(false);
const responseValues = ref({});

/**
 * Computed
**/
const visibleSlides = computed(() => {
    const fieldsets = getFormFieldsets();
    if(!fieldsets) return [];

    var currentSlides = JSON.parse(JSON.stringify(fieldsets));
    var returnSlides = [];
    var preparedSlides = [];
    var preparedSlidesPages = [];

    currentSlides.forEach((slide, index) => {
        var newFields = [];
        slide.element_details.fieldsets.forEach(el => {
            el.newClass = '';

            if(el.cssClass) {
                setClass(el);
            }

            el.newType = returnField(el);

            if (!isRuntimeVisible(el)) return;

            if(isFieldVisible(el)) {
                newFields.push(el);
            }
        
        });


        if(newFields.length > 0) {
            slide.element_details.fieldsets = newFields;
            preparedSlides.push(slide);
            preparedSlidesPages.push(index);
        }
    });

    var latestIndex = 0;
    var latestRequired = false;

    preparedSlides.forEach((slide, index) => {
        var isRequired = !!slide.element_details.fieldsets.find(el => el.isRequired == true) ? true : false;

        if(index <= (currentPage.value - 1)) {
            returnSlides.push(slide);
            
            if(latestIndex == index -1 && !latestRequired){
                if(!isRequired) {
                    returnSlides.push(slide);
                }
            }
            
            goToPrevPage.value = preparedSlidesPages[index - 1];
            goToNextPage.value = preparedSlidesPages[index + 1];
        }

        latestRequired = true;
        latestIndex = index;
    })

    pagesArray.value = preparedSlidesPages;

    return returnSlides;
});

/**
 * Prepare the classes for the slides
 * @param el object 
**/
function setClass(el) {
    const spitClasses = el.cssClass.split(' ').filter(Boolean);
    const colToken = spitClasses.find(cls => /^col-\d+(?:-\d+)?$/.test(cls));
    const otherClasses = spitClasses.filter(cls => cls !== colToken);

    if (colToken) {
        const colSize = colToken.split('-')[1]; // first size wins (e.g. col-6-1 -> 6)
        const base = [`col-md-${colSize}`, 'col-12'];
        // keep original token plus remaining classes to preserve any custom hooks
        const rest = [colToken, ...otherClasses].filter(Boolean);
        el.newClass = [...base, ...rest].join(' ');
    } else {
        el.newClass = `col-12 ${el.cssClass}`;
    }

    if (spitClasses.includes('normal-checkbox')) {
        el.checkboxmode = 'normal';
    }

    if (spitClasses.includes('hide-title')) {
        el.checkboxHideTitle = true;
    }
}

function validateField(field, child) {
    const errs = {
        error: {},
        errors: []
    }
    const err = []
    if (field?.isRequired) {
        const val = child.value
        const empty = val === null || val === undefined || (typeof val === 'string' && val.trim() === '') || (Array.isArray(val) && val.length === 0)
        if (empty) {
            errs.errors.push({"message": 'Dieses Feld muss ausgefüllt sein.'});
            errs.error["message"] = 'Dieses Feld muss ausgefüllt sein.';
        }
    }

    if (field?.type === 'specialistFilterResultContainer') {
        const val = Array.isArray(child.value) ? child.value.filter(Boolean) : (child.value ? [child.value] : []);
        const maxSelectionCount = getSpecialistMaxSelectionCount();

        if (val.length > maxSelectionCount) {
            const message = maxSelectionCount === 1
                ? 'Es kann nur ein Fachbetrieb ausgewählt werden.'
                : `Es können maximal ${maxSelectionCount} Fachbetriebe ausgewählt werden.`;

            errs.errors.push({ message });
            errs.error["message"] = message;
        }
    }

    return errs
}

function getSpecialistMaxSelectionCount() {
    return ogData.value?.form?.formType === 'application' ? 5 : 1;
}

function validateAll() {
    var allValid = true;

    for(const key in validateForm.value) {
        var parent = validateForm.value[key];
        
        for(const childkey in parent) {
            var child = parent[childkey];
            var find;

            if(childkey === '_wd_search_box') {
                child = parent[childkey]['wd_send_to_specialist'];
                visibleSlides.value.forEach(el => {
                    find = el.element_details.fieldsets.find(i => i.id == child.id)
                })

                const errs = validateField(find, child);
                child.errors = errs.errors;
                child.error = errs.error;
                child.invalid = errs.errors.length > 0;
                child.valid = errs.errors.length === 0;
                parent[childkey].errors = errs.errors;
                parent[childkey].error = errs.error;
                parent[childkey].invalid = errs.errors.length > 0;
                parent[childkey].valid = errs.errors.length === 0;
                if (errs.errors.length > 0) allValid = false;
                continue;
            }

            visibleSlides.value.forEach(el => {
                find = el.element_details.fieldsets.find(i => i.id == child.id)
            })

            const errs = validateField(find, child);
            child.errors = errs.errors;
            child.error = errs.error;
            child.invalid = errs.errors.length > 0;
            child.valid = errs.errors.length === 0;
            // console.log('validateAll', find, errs.errors)
            if (errs.errors.length > 0) allValid = false  
        } 
    }
    return allValid
}

const onFormSubmit = async (e) => {
    var valid = validateAll();

    if(!valid) {
        await updateSwiperAutoHeight();
    }
    else if(currentSlide.value == maxPages.value) {
        if(valid) {
            await submitForm(valid, responseValues.value);
        }
        return true;
    }
    else if(currentSlide.value < currentPage.value) {
        swiperInstance.value?.slideTo((currentSlide.value));
    } else if (valid) {
        addSlide();
        await updateSwiperAutoHeight();
    }
};

async function submitForm(valid, values) {
    try {
        formIsSubmitting.value = true;
        await updateSwiperAutoHeight();
        var submitUrl = '/de/zvshk-portal/api/form-send/send';
        const formDataToSend = new FormData();

        var newValue = JSON.parse(JSON.stringify(values))

        addHiddenLeadRevocationValues(newValue);

        // for(const key in newValue) { 
        //     for (const childkey in newValue[key]) {
        //         if(Array.isArray(newValue[key][childkey]) && newValue[key][childkey].length == 1 ) {
        //             newValue[key][childkey] = `['${newValue[key][childkey]}']`;
        //         }
        //     }
        // }

        appendFormData(formDataToSend, newValue);
        appendFormData(formDataToSend, formFiles.value);
        formDataToSend.append('uid', queryUID);
        if(querySUID != '') formDataToSend.append('suid', querySUID);
        formDataToSend.append('response-type', 'json');
        submitUrl = submitUrl + '?uid=' + queryUID;
        
        // console.log('formDataToSend------------------------------')
        // for (const [key, value] of formDataToSend.entries()) {
        //     console.log(key + ':', value);
        // }
        // console.log('formDataToSend end ------------------------------')

        // return
        const response = await axios.post(submitUrl, formDataToSend, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        if(response.data.validationResult?.isValid == false) {
            showErrorMessage.value = true;
            formIsSubmitting.value = false;
        } else {
            showErrorMessage.value = false;
            formSubmitted.value = true;
            formFinishedHtml.value = response.data.formFinished;
        }

    } catch (error) {
        formIsSubmitting.value = false;
        console.error('Fehler beim Formular-Submit:', error);
    }
};

/**
 * Watcher
**/

watch(() => visibleSlides.value,
    async (newValue) => {
        var slides = newValue;
        if(!slides) return;

        var preValidateFrom = {valid: true};

        // remove not visible elements
        if(validateForm.value !== null && Object.keys(validateForm.value).length > 1) {
            for(const key in validateForm.value) {
                if(key === 'valid') continue;

                // check the pages
                let find = slides.find(page => page.name == key);

                if(find == undefined) {
                    delete validateForm.value[key];
                } 

                // check for childs
                if(Object.keys(validateForm.value[key])?.length > 0) {

                    
                    for(const childkey in validateForm.value[key]) {
                        let findChild = find.element_details.fieldsets.find(field => field.element_details.name == childkey);

                        if(findChild == undefined) {
                            delete validateForm.value[key][childkey];
                        }
                    }
                }
            }
            preValidateFrom = validateForm.value;
        }

        slides.forEach(page => {
            page.element_details.fieldsets.forEach(field => {
                if (!(page.name in preValidateFrom)) {
                    preValidateFrom[page.name] = {};
                }

                if(field.newType == 'specialistFilterResultContainer') {
                    if (!('_wd_search_box' in preValidateFrom[page.name])) {
                        preValidateFrom[page.name]['_wd_search_box'] = {};
                        preValidateFrom[page.name]['_wd_search_box']['wd_send_to_specialist'] = {
                            id: field.id,
                            value: [],
                            touched: false,
                            dirty: false,
                            pristine: true,
                            valid: true,
                            invalid: false,
                            errors: []
                        };
                    }
                } 
                else if (field.newType == 'specialistFilter') {
                    if (!(field.element_details.name in preValidateFrom[page.name])) {
                        preValidateFrom[page.name][field.element_details.name] = {
                            id: field.id,
                            value: {
                                sf_plzInputValue: '',
                                sf_plzRangeValue: 10,
                                sf_companyValue: '',
                                sf_select: 'Postleitzahl',

                            },
                            touched: false,
                            dirty: false,
                            pristine: true,
                            valid: true,
                            invalid: false,
                            errors: []
                        };
                    }
                }

                else {
                    if (!(field.element_details.name in preValidateFrom[page.name])) {

                        var value = null;
                        if(JSON.parse(JSON.stringify(initialValues.value)).hasOwnProperty(field.id)) {
                            value = JSON.parse(JSON.stringify(initialValues.value))[field.id];
                        }

                        // console.log('test', JSON.parse(JSON.stringify(initialValues.value)), JSON.parse(JSON.stringify(initialValues.value)).hasOwnProperty(field.id), field.id);

                        preValidateFrom[page.name][field.element_details.name] = {
                            id: field.id,
                            value: value,
                            touched: false,
                            dirty: false,
                            pristine: true,
                            valid: true,
                            invalid: false,
                            errors: []
                        };
                    }
                }

            })
        })


        validateForm.value = JSON.parse(JSON.stringify(preValidateFrom));
        validateFormSaver.value = JSON.parse(JSON.stringify(preValidateFrom));
        updateSwiperAutoHeight();
    },
    { 
        deep: true,
        immediate: true,
    }
)

watch(() => validateForm.value,
    (newValue) => {
        if(!newValue) return;
        // console.log(JSON.stringify(newValue) == JSON.stringify(oldvalidateFromSaver.value));
        if(JSON.stringify(newValue) == JSON.stringify(oldvalidateFromSaver.value)) return;
        oldvalidateFromSaver.value = JSON.parse(JSON.stringify(newValue));


        responseValues.value = {}

        var newFormData = JSON.parse(JSON.stringify(formData.value));

        for(const key in newValue) {
            if(key == 'valid') continue;

            // console.log('watch', key);

            if(key in responseValues.value == false) {
                responseValues.value[key] = {}
            }

            for(const k in newValue[key]) {
                var id = newValue[key][k].id;
                var value = newValue[key][k].value;
                // console.log('newValue', newValue);

                if(k === '_wd_search_box') {
                    id = newValue[key][k]['wd_send_to_specialist'].id;
                    value = newValue[key][k]['wd_send_to_specialist'].value;
                }

                if(value == null || newFormData == undefined || value.length == 0) {
                    delete newFormData[id];
                    delete responseValues.value[key][k];
                    const fieldMeta = getFieldById(id);
                    if(fieldMeta) updateSearchParams(fieldMeta, []);

                    
                } else {
                    newFormData[id] = value;
                    const fieldMeta = getFieldById(id);
                    if(fieldMeta) updateSearchParams(fieldMeta, value);

                    if(k === '_wd_search_box') {
                        responseValues.value[key][k] = {};
                        responseValues.value[key][k]['wd_send_to_specialist'] = value;
                    } else {
                        responseValues.value[key][k] = value;
                        initialValues.value[id] = value;
                    }
                }

            }

        }
        formData.value = JSON.parse(JSON.stringify(newFormData));
    },
    {
        deep: true,
        immediate: true,
    }
)

// info Toggle
const popovers = ref([]);

const toggle = (index, event) => {
  popovers.value[index]?.toggle(event);
};

// computed
const currentStep = computed(() => {
    if (!maxPages.value) return 0;
  return (100 / maxPages.value) * currentSlide.value;
});


// on mounted
onMounted(async () => {
    getData();
});

// forms
// prefill
const initialValues = ref({});

function getFormFieldsets(data = ogData.value) {
    if (!data?.form || !Array.isArray(data.form.fieldsets)) {
        return null;
    }

    return data.form.fieldsets;
}

async function updateSwiperAutoHeight() {
    await nextTick();
    swiperInstance.value?.updateAutoHeight(0);
}

function appendFormData(formData, data, parentKey = '') {
    // const ignoreKeys = ['sf_select', 'sf_plzInputValue', 'sf_plzRangeValue', 'sf_companyValue'];
    

    if (Array.isArray(data)) {
        // if (data.length === 1) {
        //     appendFormData(formData, data[0], parentKey);
        // } else {
            data.forEach((value) => {
                appendFormData(formData, value, parentKey + '[]');
            });
        // }
    } else if (typeof data === 'object' && data !== null && !(data instanceof File)) {
        Object.entries(data).forEach(([key, value]) => {
            // console.log(key, value);
            // if (ignoreKeys.includes(key)) {
            //     return;
            // }
            if (key === '_wd_filter') {
                Object.entries(searchParams.value).forEach(([searchKey, searchValue]) => {
                    const filterKey = parentKey ? `${parentKey}[${key}][${searchKey}]` : `${key}[${searchKey}]`;
                    if (searchValue !== null && searchValue !== undefined) {
                        formData.append(filterKey, searchValue);
                    }
                });
            } else {
                const formKey = parentKey ? `${parentKey}[${key}]` : key;
                appendFormData(formData, value, formKey);
            }
        });
    } else {
        // if (ignoreKeys.includes(parentKey) || data === null || data === undefined) {
        //     return;
        // }

        formData.append(parentKey, data);
    }
}

function isNormalCheckbox(fieldMeta) {
    var isMultiCheckbox = fieldMeta.type == "multiCheckbox";
    var hasOneValue = fieldMeta.valueOptions.length === 1;
    var isNormalCheckbox = fieldMeta.cssClass?.indexOf('normal-checkbox') !== -1;

    return (isMultiCheckbox && hasOneValue && isNormalCheckbox);
}

const submitCurrentSlide = () => {
    const el = formEl.value
    if (el?.requestSubmit) el.requestSubmit()
    else if (el?.submit) el.submit()
}

function updateFormFiles(step, item, value) {
    if (!formFiles.value[step.name]) {
        formFiles.value[step.name] = {};
    }
    if (!formFiles.value[step.name][item.element_details.name]) {
        formFiles.value[step.name][item.element_details.name] = {};
    }
    if (item.isMultipleFileUpload) {
        formFiles.value[step.name][item.element_details.name].file = Array.isArray(value) ? value : value ? [value] : [];
    } else {
        if (Array.isArray(value)) {
            formFiles.value[step.name][item.element_details.name].file = value[0] ?? null;
        } else {
            formFiles.value[step.name][item.element_details.name].file = value ?? null;
        }
    }
    // console.log('value', value);
    // console.log('formFiles', formFiles);
}

async function handleUpdateModelValue(step, item, val) {
    updateSearchParams(item, val);
    await updateSwiperAutoHeight();
}

function getFormElementName(step, item) {
    if(item.type == 'specialistFilterResultContainer') {
        return `${step.name}[_wd_search_box][wd_send_to_specialist]`;
    }
    return `${step.name}[${item.element_details.name}]`;
}

function getFieldById(id) {
    if(!ogData.value?.form?.fieldsets) return null;

    for(const page of ogData.value.form.fieldsets) {
        const field = page.element_details.fieldsets.find(item => item.id == id);
        if(field) return field;
    }

    return null;
}

function updateSearchParams(item, value) {
    const linkedField = item?.attributes?.['data-linked-search-field'];
    const searchUids = item?.attributes?.['data-search-uids'];

    if (!linkedField || !searchUids) return;

    let searchUidsObj;
    try {
        searchUidsObj = typeof searchUids === 'string' ? JSON.parse(searchUids) : searchUids;
    } catch (e) {
        searchUidsObj = {};
    }

    const normalizeValue = (selectedValue) => {
        if(selectedValue && typeof selectedValue === 'object' && 'id' in selectedValue) {
            return selectedValue.id;
        }
        return selectedValue;
    };

    const selectedIds = Array.isArray(value) ? value.map(normalizeValue) : [normalizeValue(value)];
    const selectedSearchStrings = selectedIds
        .map(id => searchUidsObj[id])
        .filter(Boolean);

    if(selectedSearchStrings.length <= 0) {
        delete searchParams.value[linkedField];
        return;
    }

    searchParams.value[linkedField] = selectedSearchStrings.join(',');
}

const validateSpecialistErrors = ref(null);

function isRequired(value, errors) {
    let message = 'Dieses Feld muss augefüllt sein.';
    if (!value) errors.push({ message: message });
    else if(value == {}) errors.push({ message: message });
    else if(value.length <= 0) errors.push({ message: message });

    return errors;
}

// functions
function onSwiper(swiper) {
    swiperInstance.value = swiper
}

async function getData() {
    progress.value = 0;
    
    //let url = '/de/zvshk-portal/api/form-generator/render';
    let url = '/de/zvshk-portal/api/form-generator/render';
    var formData = new URLSearchParams();
    formData.append('uid', queryUID);
    // formData.append('uid', '08d85810-3e14-49cf-8d3a-01f640bb6396');
    if(querySUID != '') formData.append('suid', querySUID);
    formData.append('response-type', 'json');
    
    try {
        const response = await axios.post(url, formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        onDownloadProgress: (progressEvent) => {
            const percent = Math.round(
                (progressEvent.loaded * 100) / progressEvent.bytes
            );
            progress.value = percent;
        },
        });

        const responseData = response.data ?? {};
        ogData.value = responseData;
        setStyle(responseData)

        const fieldsets = getFormFieldsets(responseData);
        if (!fieldsets) {
            placeholderHtml.value = responseData.placeholderPage || '<div></div>';
            loading.value = false;
            return;
        }

        const isPrivate = !!ogData.value.isPrivateForm;

        // console.log('test', isPrivate)

        if(isPrivate) {
            ogData.value.form.fieldsets.forEach(page => {
                page.element_details.fieldsets = page.element_details.fieldsets.filter(
                    el => ['specialistFilter', 'specialistFilterResultContainer'].includes(el.type) == false
                );
            });
        }

        ogData.value.form.fieldsets = ogData.value.form.fieldsets
            .map(slide => {
                slide.element_details.fieldsets = slide.element_details.fieldsets.filter(item => {
                    if (typeof item.specialistShowMode === 'number') {
                        if (item.specialistShowMode === 0) return true;
                        if (item.specialistShowMode === 1) return !isPrivate;
                        if (item.specialistShowMode === 2) return isPrivate;
                        return false;
                    }
                    if (isPrivate) {
                        const isException = privateFieldExceptions.value.includes(item.type);
                        return !isException;
                    }
                    return true;
                });
                return slide;
            })
        
        ogData.value.form.fieldsets.forEach(page => {
            page.element_details.fieldsets = page.element_details.fieldsets.filter(
                el => el.hidden == false
            );
        });

        initPrefillValues(responseData);

        ogData.value.form.fieldsets = ogData.value.form.fieldsets.filter(
            page => page.element_details.fieldsets.length > 0
        );
        
        // add max pages
        maxPages.value = responseData.form.fieldsets.length;

        // debug
        // console.log(ogData.value)

        // end of animation
        setTimeout(() => {
            loading.value = false;
        }, 100)

    } catch (error) {
        placeholderHtml.value = '<div></div>';
        loading.value = false;
        console.error('Fehler beim Download:', error);
    }
};

function setStyle(data) {
    document.documentElement.style.setProperty('--color-main',                              data.mainColor ?? '#0074bc');
    document.documentElement.style.setProperty('--p-primary-color',                         data.mainColor ?? '#0074bc');
    document.documentElement.style.setProperty('--swiper-theme-color',                      data.mainColor ?? '#0074bc');
    document.documentElement.style.setProperty('--p-button-primary-background',             data.mainColor ?? '#0074bc');
    document.documentElement.style.setProperty('--p-button-primary-border-color',           data.mainColor ?? '#0074bc');
    document.documentElement.style.setProperty('--p-button-primary-hover-background',       data.mainColor ?? '#0074bc');
    document.documentElement.style.setProperty('--p-button-primary-hover-border-color',     data.mainColor ?? '#0074bc');
    document.documentElement.style.setProperty('--p-button-primary-active-background',      data.mainColor ?? '#0074bc');
    document.documentElement.style.setProperty('--p-button-primary-active-border-color',    data.mainColor ?? '#0074bc');
    
    // hover reset
    document.documentElement.style.setProperty('--p-primary-hover-color', '#56545f');
    document.documentElement.style.setProperty('--p-node-second-background-color', '#cbd5e1');
    document.documentElement.style.setProperty('--p-node-third-background-color', '#ffffff');
}

async function initPrefillValues(responseData) {
    const fieldsets = getFormFieldsets(responseData);
    if (!fieldsets) return;

    fieldsets.forEach(slide => {
        slide.element_details.fieldsets.forEach(item => {
            const fieldName = getFormElementName(slide.element_details, item);
            formNames.value[fieldName] = item;

            
            if (!(fieldName in initialValues.value)) {
                let num = item.value;
                if (
                    item.type === 'radio' ||
                    item.type.startsWith('termsAndConditions')
                ) {
                    num = Number(item.value);
                }
                initialValues.value[item.id] = (!isNaN(num) && item.value !== '' && item.value !== null) ? num : item.value;
                // formData.value[item.id] = (!isNaN(num) && item.value !== '' && item.value !== null) ? num : item.value;
            }
        });
    });
}

async function addSlide() {
    const nextVisibleIndex = visibleSlides.value?.length ?? 0;

    currentPage.value++
    await nextTick();

    swiperInstance.value?.update();
    swiperInstance.value?.slideTo(nextVisibleIndex);
}

async function onSlideChange(event) {
    await nextTick();
    currentSlide.value = (pagesArray.value[event.activeIndex]) + 1;
    
    const nextSlide = visibleSlides.value.at(-1);
    if (nextSlide?.element_details?.fieldsets?.some(f => f.type === 'specialistFilterResultContainer')) {
        specialistResults.value = null;

        try {
            let response = await getSpecialistResults();
            specialistResults.value = response.data;
            await updateSwiperAutoHeight();
        } catch (e) {
            console.log('ERROR:', e);
            specialistResults.value = { error: true };
        }
    }

    await nextTick();

    const swiper = swiperInstance.value;
    const activeSlide = swiper.slides[swiper.activeIndex];

    await nextTick();
    setTimeout(() => {
        const heading = activeSlide.querySelector('.label .headline');

        if (heading) {
            heading.setAttribute('tabindex', '-1');
            heading.focus();
        } else {
            const focusable = activeSlide.querySelector(
                'input, select, textarea, button, [tabindex]:not([tabindex="-1"])'
            );
            
            if (focusable) {
                focusable.focus();
            } else {
                activeSlide.setAttribute('tabindex', '-1');
                activeSlide.focus();
            }
        }
    }, 300);
    
}

async function getSpecialistResults() {
    let getSpecialistsUrl = '/de/zvshk-portal/api/form-generator/get-specialists';
    const ajaxFormData = new FormData();
    ajaxFormData.append('uid', queryUID);
    var nextSlide = visibleSlides.value.at(-1);

    Object.entries(searchParams.value).forEach(([key, val]) => {
        ajaxFormData.append(`${nextSlide.name}[_wd_filter][${key}]`, val ?? '');
    });

    let sf_select = getFormValue('sf_select')
    var searchmode = '';
    if(sf_select == 'Postleitzahl') {
        searchmode = 'postcode';
        ajaxFormData.append(`${nextSlide.name}[_wd_filter][wd_postcode]`, getFormValue('sf_plzInputValue') ?? '');
        ajaxFormData.append(`${nextSlide.name}[_wd_filter][wd_postcode_radius]`, getFormValue('sf_plzRangeValue') ?? '');
    } else if(sf_select == 'Firmenname') {
        searchmode = 'text';
        ajaxFormData.append(`${nextSlide.name}[_wd_filter][wd_search]`, getFormValue('sf_companyValue'));
    }

    ajaxFormData.append(`${nextSlide.name}[_wd_filter][searchmode]`, searchmode ?? '');


    const response = await axios.post(getSpecialistsUrl, ajaxFormData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    
    return response;
}

function getFormValue(fieldName) {

    for(const key in responseValues.value) {
        for(const childkey in responseValues.value[key]) {
            if(childkey == '_wd_filter') {
                return responseValues.value[key][childkey][fieldName]
            }
        }
    }

//   const root = formRef && formRef.value ? formRef.value : formRef;
//   const root = validateForm && validateForm.value ? validateForm.value : validateForm;

//     for (const key in root) {
//         const value = root[key];
//         if (!value || typeof value !== "object") {
//             continue;
//         }

//         if (key === fieldName) {
//             if ("value" in value) return value.value;
//             if ("modelValue" in value) return value.modelValue;
//             return null;
//         }

//         if (fieldName in value) {
//             let meta = value[fieldName];
//             if ("value" in meta) return meta.value;
//             if ("modelValue" in meta) return meta.modelValue;
//             return null;
//         }
//     }

  return null;
}

function returnField(item) {
    if(item?.cssClass?.indexOf('big') >= 0) {
        if(item.type == 'radio')    return 'bigRadio'
        if(item.type == 'checkbox') return 'bigCheckboxes'
        if(item.type == 'multiCheckbox') return 'bigCheckboxes'
    }
    if(item.type == 'multiCheckbox') return 'multiCheckbox'
    if(item.type == 'email') return 'text'
    if(item.type == 'termsAndConditionsCheckboxGDPR') return 'termsAndConditions'
    if(item.type == 'termsAndConditionsCheckboxSpecialistAGB') return 'termsAndConditions'
    if(item.type == 'termsAndConditionsCheckboxSpecialistGDPR') return 'termsAndConditions'
    if(item.type == 'preventAutomaticReassignmentCheckbox') return 'termsAndConditions'
    if(item.type == 'termsAndConditionsCheckboxGDPRApplication') return 'termsAndConditions'
    if(item.type == 'leadRevocationCheckBox') return 'termsAndConditions'
    if(item.type == 'vacanciesJobSelect') return 'openApprenticeshipsSelect'
    if(item.type == 'openPositionsSelect') return 'openApprenticeshipsSelect'
    if(item.type == 'openApprenticeshipsSelect') return 'openApprenticeshipsSelect'
    if(item.type == 'range') return 'rangeSlider'
    if(item.type == 'phone') return 'text'
    return item.type
}

const checkResolver = ({value, name}) => {
    const item = formNames.value[name];
    var errors = [];
    if(!item || !isFieldVisible(item)) {
        return { errors };
    }
   
    if(item.isRequired == true) {
        errors = isRequired(value, errors);
    }

    switch(item.type) {
        case 'phone':
            if (!isEmpty(value) && !/^(\+?\d[\d\s\-]{5,})$/.test(value)) {
                errors.push({ message: 'Bitte eine gültige Telefonnummer eingeben.' });
            }
            break;
        case 'email':
            if (!isEmpty(value) && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                errors.push({ message: 'Bitte eine gültige E-Mail-Adresse eingeben.' });
            }
            break;
        case 'specialistFilter':
            return { specialistFilterErrors };
    }

    return {
        errors
    };
}


function isEmpty(val) {
  return (
    val === undefined ||
    val === null ||
    (typeof val === 'string' && val.trim() === '') ||
    (Array.isArray(val) && val.length === 0)
  )
}

async function slideBack(val) {
    const previousVisibleIndex = Math.max(val - 1, 0);

    currentPage.value--
    await nextTick();

    swiperInstance.value?.update();
    swiperInstance.value?.slideTo(previousVisibleIndex);
}

function getButtonLabel(button) {
    if (/submit/i.test(button.label)) return 'Absenden';
    if (/next/i.test(button.label)) return 'Weiter';
    if (/back/i.test(button.label)) return 'Zurück';
    return button.label;
}

function getSelectState(type) {
    if(type == 'radio') return '(Einzelauswahl)';
    if(type == 'multiCheckbox') return '(Mehrfachauswahl)';
    return '';
    
}

watch(showErrorMessage, async (val) => {
    if (val === true) {
        await updateSwiperAutoHeight();
    }
});

</script>
